import React, { useEffect, useState } from 'react'

import { IProductSearch, IProductsQuery } from '@core/api/Products/types'
import { LYSContainer, LYSTypography } from '@core/components/Primitives'
import ProductCarousel from '@core/components/ProductCollection/ProductCarousel'
import { RecommendationTypes } from '@core/api/Recommendations/types'
import { useTranslation } from '@core/i18n/i18n'
import style from './index.module.less'
import cn from 'classnames'
import { useServices } from '@core/utils/ioc'
import { usePageContext } from '@core/utils/pages/PageContext'

interface Props {
  titleStyle?: string
  variantId?: string
}

const LastViewedProductsSlider: React.FC<Props> = ({
  titleStyle,
  variantId,
}) => {
  const { t } = useTranslation()
  const [products, setProducts] = useState<IProductSearch[]>([])
  const { api } = useServices()
  const [recommendedVariantIds, setRecommendedVariantIds] = useState<string[]>()
  const [isLoading, setLoading] = useState<boolean>(false)

  const {
    props: { isMobile },
  } = usePageContext()
  useEffect(() => {
    const fetchRecommendations = async () => {
      setLoading(true)

      const recommendationsResponse =
        await api.recommendations.fetchRecommendationsByType(
          RecommendationTypes.LAST_VIEWED_VARIANTS
        )

      setRecommendedVariantIds(
        recommendationsResponse?.recommendations.map((rec) => rec.variantId)
      )
    }
    fetchRecommendations()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [variantId])

  useEffect(() => {
    const fetchProducts = async (params: IProductsQuery) => {
      const { hits } = await api.products.fetchProducts(params)

      if (hits && hits?.length > 0) {
        hits.sort((a, b) => {
          return (
            recommendedVariantIds!.indexOf(a.mainVariant.id) -
            recommendedVariantIds!.indexOf(b.mainVariant.id)
          )
        })
        setProducts(hits)
      }
    }

    if (recommendedVariantIds && recommendedVariantIds.length) {
      const params: IProductsQuery = {
        filter: {
          variantId: recommendedVariantIds,
        },
        search: '',
        page: 1,
        requiresAggregations: 0,
      }

      fetchProducts(params)
    }
    setLoading(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recommendedVariantIds])

  return products.length > 0 ? (
    <LYSContainer padded={isMobile ? false : true}>
      <LYSTypography.Title
        level={2}
        visualAppearance={'h3'}
        className={cn(style.titleCenter, titleStyle)}
      >
        {t(`recommendations.title.last_viewed_variants`)}
      </LYSTypography.Title>
      <ProductCarousel
        minimizedCard={true}
        productItems={products}
        loading={isLoading}
      />
    </LYSContainer>
  ) : null
}

export default LastViewedProductsSlider
